<template>
  <v-dialog
    :value="value"
    max-width="1200"
    scrollable
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="justify-center my-5 guide-title"
        >胸高直徑測量位置</v-card-title
      >
      <v-card-text>
        <!-- <p>
          一般於離地 1.3
          公尺處測量；若該處分岔，往下取未分枝、未膨大處。若已分枝，請分別測量各枝幹，再使用分枝轉換。
        </p> -->
        <div
          class="guide-image-wrap"
          tabindex="0"
          aria-label="測量說明圖片，可左右捲動查看"
        >
          <img
            :src="guideSrc"
            alt="胸高直徑測量位置：一般情況、1.3 公尺處分岔、已分枝的測量方式與多主幹胸徑換算公式"
            class="guide-image"
          />
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="justify-center py-4">
        <v-btn color="#FFF777" @click="$emit('input', false)">關閉視窗</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: { value: Boolean },
  data: () => ({
    guideSrc: require("@/assets/images/carbon/measurement-guide.png")
  })
};
</script>

<style scoped>
.guide-title {
  font-size: clamp(1.2rem, 2.1vw, 2rem) !important;
  line-height: 1.1;
  color: #0f7c1f;
  font-weight: 700 !important;
  word-break: normal;
}
.guide-image-wrap {
  overflow-x: auto;
}
.guide-image {
  display: block;
  width: 100%;
  min-width: 900px;
  height: auto;
}
</style>
